module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar-cha"
  }, [_c('a', {
    attrs: {
      "id": "file_009"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2c"
  }, [_c('strong', [_vm._v("THE HELLCAT’S ORIGINS")])])])]), _c('a', {
    attrs: {
      "id": "file_009"
    }
  }), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "file_009"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_009"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("A pair of sharp-looking Grumman F3F-3s patrol near the "), _c('em', [_vm._v("Yorktown.")]), _vm._v(" The planes flew in threes; the section leader has a completely red cowling and the number two man is flying above and to the left. The third man is shooting the photo. The distinctive “diving eagle” insignia of VF-5 is barely visible under the cockpit rail. "), _c('em', [_vm._v("U.S. Navy via Stan Piet")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1875d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_009.vue
// module id = 78
// module chunks = 0